import React, { FC, useCallback } from 'react';
import { FlexGrid } from '../../../../../components/FlexGrid';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { openNewWindow } from './utils';
import { PublicJobDetailShareLink } from './PublicJobDetailShareLink';
import { PublicJobDetailShareButton } from './PublicJobDetailShareButton';
import { usePublicJobDetailShareData } from './hooks/usePublicJobDetailShareData';

export const PublicJobDetailShareButtons: FC = () => {
	const {
		data: { title },
	} = usePublicJobDetailDataQuery();
	const socialData = usePublicJobDetailShareData(title);
	const handleShareButtonClick = useCallback((url: string) => () => openNewWindow(url), []);

	return (
		<FlexGrid>
			{socialData.map(({ icon, shareUrl, type, target }) => {
				if (target === 'self') {
					return (
						<PublicJobDetailShareLink
							href={shareUrl}
							key={type}
						>
							{icon}
						</PublicJobDetailShareLink>
					);
				}

				return (
					<PublicJobDetailShareButton
						onClick={handleShareButtonClick(shareUrl)}
						key={type}
					>
						{icon}
					</PublicJobDetailShareButton>
				);
			})}
		</FlexGrid>
	);
};
